import React from 'react';
import { Link } from 'react-router-dom';
import './CTA.css';

const CTA: React.FC = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <div className="cta-content">
          <h2 className="cta-title" data-aos="fade-up">
            Ready to visualize your neural networks?
          </h2>
          <div className="cta-buttons" data-aos="fade-up" data-aos-delay="200">
            <Link to="/signin" className="btn btn-primary">
              <span className="btn-content">
                Get Started
                <span className="btn-arrow">→</span>
              </span>
            </Link>
            <a href="#features" className="btn btn-secondary">
              Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;

